// extracted by mini-css-extract-plugin
export default {"rule":"Bn4ol","rule--valid":"TRBCS","rule--critical":"xwZKF"};